module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0yMC4yNSAxMC43NTIyTDMuNzU1MiAzVjUuNjk0NkwxNy4zNjUyIDEyLjA5MDlMMy43NSAxOC40MDEyTDMuNzUyNiAyMUgzLjc1NTJMMjAuMjUgMTMuNDAwMVYxMC43NTIyWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHg9IjMuNzUiIHk9IjMiIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-arrow-right.svg
// module id = 5a7B
// module chunks = 1